import { render, staticRenderFns } from "./qx-pagination.vue?vue&type=template&id=508d178e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d178e",
  null
  
)

export default component.exports